import React from 'react';
import AsyncPage from './async';
import {Route} from 'react-router-dom';

export default [
  <Route
    key="/business/products/ai-shade-finder"
    path="business/products/ai-shade-finder"
    element={<AsyncPage />}
  />,
];
